import { TypeHelper } from "../../helpers"

import { OpDashboard } from "../../models/custom"

export class DashboardHelper {

    // Consts

    public static get DASHBOARD_NAME_DEFAULT_LOCALIZATION_TEXT(): string { return 'Home' }

    // Consts End

    
    // Module Setup

    public static getDashboardUniqueNames(dashboards: OpDashboard[]): { [index: number]: { caption: string, resource: string } } {
        if (dashboards == null) {
            return {}
        }

        const uniqueNamesDict: { [index: number]: { caption: string, resource: string } }  = {}
        const namesCountDict = dashboards.reduce((dict: any, dashboard: OpDashboard) => {
            const nameKey: string = DashboardHelper.getDashboardName(dashboard) || DashboardHelper.DASHBOARD_NAME_DEFAULT_LOCALIZATION_TEXT

            if (dict[nameKey] == null) {
                dict[nameKey] = 0
            }

            dict[nameKey]++

            return dict
        }, {})
        

        const usedNumbers: any = {}
        
        dashboards.forEach((dashboard: OpDashboard) => {
            const nameKey: string = DashboardHelper.getDashboardName(dashboard) || DashboardHelper.DASHBOARD_NAME_DEFAULT_LOCALIZATION_TEXT

            let resource = DashboardHelper.DASHBOARD_NAME_DEFAULT_LOCALIZATION_TEXT
            let caption = TypeHelper.emptyString

            if (DashboardHelper.getDashboardName(dashboard) != null) {
                resource = null
                caption = DashboardHelper.getDashboardName(dashboard)
            }

            if (namesCountDict[nameKey] > 1) {
                if (usedNumbers[nameKey] == null) {
                    usedNumbers[nameKey] = 1
                }

                caption += TypeHelper.space + (usedNumbers[nameKey]++).toString()
            }

            uniqueNamesDict[dashboard.idDashboard] = {
                caption,
                resource
            }
        })

        return uniqueNamesDict;
    }

    public static getDashboardMenuIndex(dashboardIndex: number): number {
        if (dashboardIndex != null) {
            return 1 + 0.001 * dashboardIndex
        }
        
        return 1
    }
    
    public static getDashboardName(dashboard: OpDashboard): string {
        if (dashboard != null && dashboard.name != null) {
            return dashboard.name.toString()
        }
    
        return null
    }

    // Module Setup End
}